import { useTranslation } from 'react-i18next';

interface SocialLink {
  url: string
  labelKey: 'instagram' | 'tiktok' | 'youtube'
  viewBox: string
  path: string
}

const SOCIAL_LINKS: SocialLink[] = [
  {
    url: 'https://www.instagram.com/r3converse/',
    labelKey: 'instagram',
    viewBox: '0 0 448 512',
    path: 'M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z',
  },
  {
    url: 'https://www.tiktok.com/@r3converse_ai',
    labelKey: 'tiktok',
    viewBox: '0 0 448 512',
    path: 'M448 209.9a210.1 210.1 0 0 1-122.8-39.25V349.4A162.6 162.6 0 1 1 185 188.3V278a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z',
  },
  {
    url: 'https://www.youtube.com/@r3Converse',
    labelKey: 'youtube',
    viewBox: '0 0 576 512',
    path: 'M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zM232.1 337.6V175.2l142.7 81.2-142.7 81.2z',
  },
];

export function SocialLinks() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center gap-4 mt-6">
      {SOCIAL_LINKS.map((link) => (
        <a
          key={link.labelKey}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t(`social.${link.labelKey}`)}
          className="text-gray-500 hover:text-white transition-colors"
        >
          <svg viewBox={link.viewBox} className="w-5 h-5" fill="currentColor" aria-hidden="true">
            <path d={link.path} />
          </svg>
        </a>
      ))}
    </div>
  );
};
